$(document).ready(function(){

	//Disable default html5 datepicker
	$('input[type=date]').on('click', function(event) {
		event.preventDefault();
	});

});
